
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';

const ModalExcluirSecretaria = (props) => {

    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        if (loading) return;
        props.onClose();
    };

    const handleAgree = async () => {
        setLoading(true);
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/excluirSecretaria/${props.secretaria.idSecretaria}`, {
                headers: {
                    Authorization: localStorage.getItem('token')
                }
            });
            if (response.data.status === 200) {
                props.onSuccess('Secretária excluída com sucesso!');
            } else {
                props.onError(response.data.message || 'Erro ao excluir secretária. Tente novamente.');
            }
        } catch (error) {
            props.onError(error.response?.data?.message || 'Erro ao excluir secretária. Tente novamente.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={handleClose}
                aria-labelledby="excluir-secretaria-title"
                aria-describedby="excluir-secretaria-description"
            >
                <DialogTitle id="excluir-secretaria-title">
                    {"Deseja realmente excluir esta secretária?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="excluir-secretaria-description">
                        {props.secretaria?.nome ? <><strong>{props.secretaria.nome}</strong> perderá o acesso ao painel. </> : null}
                        Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}>
                    <Button onClick={handleClose} disabled={loading} variant='contained' color='success' size='small'>Manter Secretária</Button>
                    <Button onClick={handleAgree} loading={loading} autoFocus color='error' size='small'>Excluir Secretária</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ModalExcluirSecretaria;
